import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ErrorBoundary from './components/common/ErrorBoundary';
import { ScrollToTopOnNavigate, BackToTop } from './components/common/ScrollBehaviour';
import PageMeta from './components/common/PageMeta';

import Home from './pages/Home';
import FarmTech from './pages/FarmTech';
import System from './pages/System';
import Architecture from './pages/Architecture';
import Dosing from './pages/Dosing';
import Safety from './pages/Safety';
import Components from './pages/Components';
import About from './pages/About';
import Membership from './pages/Membership';
import Sustainability from './pages/Sustainability';
import Experiences from './pages/Experiences';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <BrowserRouter>
          {/* Both must sit inside the router - they read the current location */}
          <ScrollToTopOnNavigate />
          <PageMeta />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/farm-tech" element={<FarmTech />} />
              <Route path="/farm-tech/system" element={<System />} />
              <Route path="/farm-tech/architecture" element={<Architecture />} />
              <Route path="/farm-tech/dosing" element={<Dosing />} />
              <Route path="/farm-tech/safety" element={<Safety />} />
              <Route path="/farm-tech/components" element={<Components />} />
              <Route path="/about" element={<About />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/sustainability" element={<Sustainability />} />
              <Route path="/experiences" element={<Experiences />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
          <BackToTop />
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;
